import { render, staticRenderFns } from "./UnAlthorized.vue?vue&type=template&id=92b4a840&"
import script from "./UnAlthorized.vue?vue&type=script&lang=js&"
export * from "./UnAlthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports